import styled from 'styled-components'

interface ITabPaneStyledProps {}

export const TabPaneStyled = styled.div<ITabPaneStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
